import PropTypes from "prop-types";

import { Loader } from "components/Loader";
import { HeroHeadingContainer } from "./HeroHeading.styles";

export const HeroHeading = ({ heading, subheading, loading }) => {
  return (
    <HeroHeadingContainer>
      <span className="heading">
        {heading} {loading && <Loader className="mx-2" />}
      </span>
      {subheading && <p className="sub-heading">{subheading}</p>}
    </HeroHeadingContainer>
  );
};

HeroHeading.propTypes = {
  heading: PropTypes.node,
  subheading: PropTypes.node,
  loading: PropTypes.bool,
};

HeroHeading.defaultProps = {
  heading: "<Heading>",
  subheading: "",
  loading: false,
};
